module.exports = __webpack_public_path__ + "img/cplus_big.c08cecd2.png";